<template>
	<div class="home">
		<!-- 左侧导航栏开始 -->
		<div v-if="!isCollapse" class="sylf">
			<div :class="isCollapse?'sylffixactive':'sylffix'">
				<!-- 折叠按钮 -->
				<div @click="isCollapse=true"  class="sylfclose">
					<i class="el-icon-d-arrow-right"></i>
				</div>
				<div class="sylftophz">
					<div class="logo">
						<img src="../assets/logo.png" alt="logo"/>
					</div>
					<span v-if="!isCollapse" class="sylfgsname">河北龙盛螺丝</span>
				</div>
				<div class="sylfmenu">
					<el-menu :router="true" text-color="#ccc" background-color="#222" default-active="1-4-1" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose" :collapse="isCollapse">
					  <el-menu-item  @click="listnav" index="/index">
					    <i class="el-icon-menu"></i>
					    <span slot="title">首页</span>
					  </el-menu-item>
					  <el-submenu v-if="userinfor.role==2" index="/workeorder">
					    <template slot="title">
					      <i class="el-icon-s-help"></i>
					      <span slot="title">生产管理</span>
					    </template>
					    <el-menu-item @click="listnav" index="/workeorder">工单管理</el-menu-item>
						<!-- <el-menu-item @click="listnav" index="/inventoryUnit">库存单位</el-menu-item> -->
						<el-menu-item @click="listnav" index="/createOperation">创建工序</el-menu-item>
						<el-menu-item @click="listnav" index="/createProduct">创建产品</el-menu-item>
						<el-menu-item @click="listnav" index="/processRoute">工艺路线</el-menu-item>
						<el-menu-item @click="listnav" index="/performance">配置绩效</el-menu-item>
					  </el-submenu>
					  <el-submenu index="/orderList">
					    <template slot="title">
					      <i class="el-icon-s-order"></i>
					      <span slot="title">报工管理</span>
					    </template>
					    <el-menu-item  @click="listnav" index="/orderList">报工列表</el-menu-item>
					  </el-submenu>
					  <el-submenu v-if="userinfor.role==2" index="/director">
					    <template slot="title">
					      <i class="el-icon-user-solid"></i>
					      <span slot="title">开通账号</span>
					    </template>
						<el-menu-item @click="listnav" index="/supervisor">主管账号</el-menu-item>
					  	<el-menu-item @click="listnav" index="/worker">工人账号</el-menu-item>
					  </el-submenu>
					</el-menu>
				</div>
				
			</div>
		</div>
		<!-- 左侧导航栏结束-->
		
		<!-- 右侧开始 -->
		<div class="syright">
			<div class="syrttop">
				<div class="syrttoplf">
					<!-- 折叠导航按钮 -->
					<el-button @click="isCollapse=!isCollapse" class="topzdbtn" size="mini" type="primary" icon="el-icon-s-fold" ></el-button>
					<span class="topnav">{{navtitle}}</span>
				</div>
				<div @click="setuserflag=!setuserflag" class="syrttoplfuser">
					<i class="el-icon-user"></i>
					<span class="username">{{userinfor.username}}</span>
				</div>
				<div v-if="setuserflag" class="sytoprtnav">
					<div @click="setpassflag=true" class="sytoprtnavlist">
						修改密码
					</div>
					<div @click="loginout" class="sytoprtnavlist">
						退出
					</div>
				</div>
			</div>
			<div class="rtmain">
				<router-view />
			</div>
		</div>
		<!-- 右侧结束 -->
		
		
		<!-- 修改密码开始 -->
		<div class="setpass">
			<el-dialog
			  title="修改密码"
			  :visible.sync="setpassflag"
			  width="50%">
			  <div class="chaungainbox">
			  	<el-form ref="setusetform" :model="setusetform" label-width="80px">
				  <el-form-item label="原密码" class="requirtinput">
				    <el-input placeholder="请输入原密码" v-model="setusetform.password"></el-input>
				  </el-form-item>
			  	  <el-form-item label="新密码" class="requirtinput">
					<el-input placeholder="请输入新密码" v-model="setusetform.newPass"></el-input>
			  	  </el-form-item>
				</el-form>
			  </div>
			  
			  <span slot="footer" class="dialog-footer">
			    <el-button @click="closetc">取 消</el-button>
			    <el-button type="primary" @click="configbtn">确 定</el-button>
			  </span>
			</el-dialog>
		</div>
		<!-- 修改密码结束 -->

	</div>
</template>

<script>
import * as IndexAPI from '@/services/index'
	export default {
		name: 'Home',
		components: {
			
		},
		data() {
			return {
				navtitle:'首页',
				//是否展开左侧菜单栏
				isCollapse: false,
				userinfor:{},
				setpassflag:false,
				setuserflag:false,
				setusetform:{
					userId: null, //主键ID
					password: "", //原密码
					newPass: "" //新密码
				}
				
			}
		},
		mounted() {	
			
			//获取用户信息
			let UserInfor=localStorage.getItem('userInfor') 
			if(UserInfor){		 	
				this.userinfor=JSON.parse(UserInfor)	
			}else{
				this.$router.push('/login')
			}
			
		},
		watch: {
			"$route.path": {
				immediate: true,
				handler(val) {
					console.log('路由变化了')
					let clientWidth=document.documentElement.clientWidth
					if(clientWidth<768){
						// 折叠面板
						this.isCollapse=true
						this.setuserflag=false
					}
					
				}
			}

		},
		methods: {
			
			
			// 修改当前用户登录密码
			configbtn(){
				if(this.setusetform.password==''){
					this.$message({
					  message: '原密码不能为空',
					  type: 'warning'
					});
					return false		
				}
				if(this.setusetform.newPass==''){
					this.$message({
					  message: '新密码不能为空',
					  type: 'warning'
					});
					return false		
				}
				const loading = this.$loading({
				          lock: true,
				          text: 'Loading',
				          spinner: 'el-icon-loading',
				          background: 'rgba(255, 255, 255, 0.7)'
				        });
				this.setusetform.userId=this.userinfor.id		
				IndexAPI.updateLoginPwd(JSON.stringify(this.setusetform)).then((res)=>{	
					loading.close();
					if(res.data.code == 0){
						this.closetc()
						this.$alert('请重新登录', '修改成功', {
						  confirmButtonText: '确定',
						  callback: action => {
							//退出
							this.loginout()
						  }
						});

					}else{
						this.$message({
						message: res.data.msg,
						type: "error",
						});
					}
					
				})	
			},
			//取消修改密码
			closetc(){
				this.setusetform={
					userId: null, //主键ID
					password: "", //原密码
					newPass: "" //新密码
				}
				this.setpassflag=false
				this.setuserflag=false
			},
			//退出
			loginout(){
				this.$store.commit('settoken', '')
				this.$store.commit('setuserinfor', {})
				localStorage.clear()
				
				this.$router.push('/login')
			},
			listnav(e){
				console.log('e',e)
				let url = e.$options.propsData.index
				console.log('url--',url)
				if(url=='/index'){
					this.navtitle='首页'
				}else if(url=='/workeorder'){
					this.navtitle='生产管理 》工单管理'
				}else if(url=='/orderList'){
					this.navtitle='报工管理 》报工列表'
				}else if(url=='/supervisor'){
					this.navtitle='开通账号 》主管账号'
				}else if(url=='/worker'){
					this.navtitle='开通账号 》工人账号'
				}else if(url=='/inventoryUnit'){
					this.navtitle='生产管理 》库存单位'
				}else if(url=='/createOperation'){
					this.navtitle='生产管理 》创建工序'
				}else if(url=='/createProduct'){
					this.navtitle='生产管理 》创建产品'
				}else if(url=='/processRoute'){
					this.navtitle='生产管理 》工艺路线'
				}else if(url=='/performance'){
					this.navtitle='生产管理 》配置绩效'
				}else{
					this.navtitle='首页'
				}
			},
			handleOpen(key, keyPath) {
			   console.log(key, keyPath);
			},
			 handleClose(key, keyPath) {
				console.log(key, keyPath);
			},

			
		}
	}
</script>

<style scoped lang="scss">
	.home{
		display: flex;
		align-items: stretch;
		
	}
	.sylf{		
		height:100%;
		width:180px;
		position: relative;
		    z-index: 9;
		::v-deep .el-submenu__title{
			text-align: left;
		}
		::v-deep .el-menu-item{
			text-align: left;
			min-width: 0;
		}
		::v-deep .el-menu{
			border-right:none;
		}
	}
	.sylffix{
		width:180px;
		background-color: #222;
		position: fixed;
		left: 0;
		top: 0;
		height: 100%;
		color: #fff;
	}
	.sylffixactive{
		width:0;
	}
	.sylftophz{
		display: flex;
		align-items: center;
		border-bottom: 1px solid rgba(255, 255, 255, 0.05);
	}
	.logo{
		width: 40px;
		height: 40px;
		margin-right: 5px;
	margin-top: 10px;
	margin-bottom: 10px;
	margin-left: 10px;
		border-radius: 10px;
	}
	.sylfgsname{
		color: #ddd;
		 font-size: 16px;
		line-height: 1;
		    overflow: hidden;
	}
	.logo img{
		width: 100%;
	}
	.syright{
		width: 80%;
		flex: 1;
		box-sizing: border-box;
		background-color: #f5f5f5;
	}
	.syrttop{
		box-sizing: border-box;
		width:100%;
		display:flex;
		justify-content: space-between;
		padding:22px;
		border-bottom: 1px solid #f5f5f5;
		background-color: #fff;
		cursor: pointer;
		position: relative;
	}
	.username{
		margin-left: 10px;
	}
	.topnav{
		color: #666;
	}
	.rtmain{
		box-sizing: border-box;
		padding: 40px;
		background-color: #fff;
		margin-top: 5px;
	}
	.sytoprtnav{
		position: absolute;
		top: 80%;
		right: 5px;
		background-color: #fff;
		padding: 10px 20px;
		border-radius: 10px;
		box-shadow: 0 0 10px rgba(0,0,0,0.1);
		
	}
	.sytoprtnavlist{
		border-bottom: 1px solid #f5f5f5;
		line-height: 2rem;
		color: #666;
		font-size: 12px;
	}
	.sytoprtnavlist:hover{
		color: #409EFF;
	}
	
	.requirtinput{
		::v-deep .el-form-item__label:before{
			content: '*';
			color: #F56C6C;
			margin-right: 4px'';
			
		}
	}
	.topzdbtn{
		margin-right: 10px;
	}
	.syrttoplfuser{
		display: flex;
		align-items: center;
	}
	.sylfclose{
		box-sizing: border-box;
		width: 26px;
		position: absolute;
		right: -26px;
		top: 50%;
		transform: translateY(-50%);
		background-color: rgba(0,0,0,0.6);
		padding: 10px 6px;
		border-top-right-radius: 50%;
		border-bottom-right-radius: 50%;
		cursor: pointer;
		display: none;
	}
	
	
	
	
</style>